
"use client";

import Link from "next/link";
import { Logo } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useUser } from "@/context/user-context";
import { Skeleton } from "@/components/ui/skeleton";

export function LandingPageHeader() {
  const { user, loading } = useUser();

  return (
    <header className="px-4 lg:px-6 h-20 flex items-center border-b border-border/20 sticky top-0 bg-background/80 backdrop-blur-sm z-50">
      <Link href="/" className="flex items-center justify-center" prefetch={false}>
        <Logo className="h-16 w-auto" />
      </Link>
      <nav className="ml-auto flex gap-2 sm:gap-4">
        {loading ? (
          <div className="flex gap-2">
             <Skeleton className="h-10 w-20" />
             <Skeleton className="h-10 w-24" />
          </div>
        ) : user ? (
           <Link href="/dashboard">
            <Button>Dashboard</Button>
          </Link>
        ) : (
          <>
            <Link href="/login">
              <Button variant="ghost">Login</Button>
            </Link>
            <Link href="/signup">
              <Button>Sign Up</Button>
            </Link>
          </>
        )}
      </nav>
    </header>
  );
}
